/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View, Platform } from 'react-native';
//@ts-ignore
import { observer } from 'mobx-react';
import TopNavigationBar, { TopNavigationBarPlaceholder } from '../components/TopNavigationBar';
//@ts-ignore
import { JDDevice, JDText, JDTouchable, JDImage, JDNativeToast } from '@jdreact/jdreact-core-lib';
//@ts-ignore
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import Radio from '../components/Radio';
import Images from '../images';
//store
import PropTypes from 'prop-types';
import store from '../services/goodsContrastPageStore/store';
import { logClick, ContrastPop, ContrastPopExpo } from '../mta/MtaService';
import { goodsItem } from '../services/goodsContrastPageStore/domain';

const { getRpx } = JDDevice;
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    width: JDDevice.getRpx(750),
    height: '100%',
  },
  mask: {
    width: getRpx(750),
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  selectDialog: {
    flexDirection: 'column',
    width: getRpx(582),
    height: getRpx(834),
    marginTop: getRpx(230),
    backgroundColor: '#ffffff',
    borderRadius: getRpx(24),
  },
  title: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: Platform.OS == 'android' ? getRpx(35) : getRpx(32),
    marginTop: getRpx(48),
    marginBottom: getRpx(32),
  },
  titleText: {
    color: '#262626',
    fontSize: getRpx(32),
    height: Platform.OS == 'android' ? getRpx(35) : getRpx(32),
    lineHeight: getRpx(35),
    fontWeight: 'bold',
  },
  current: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: getRpx(538),
    height: getRpx(148),
    backgroundColor: 'rgba(255,243,241,1)',
    borderTopRightRadius: getRpx(12),
    borderBottomRightRadius: getRpx(50),
    marginBottom: getRpx(20),
    paddingLeft: getRpx(24),
  },
  goodsList: {
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    alignSelf: 'flex-end',
    width: getRpx(538),
    height: getRpx(420),
    backgroundColor: 'rgba(240,244,255,1)',
    borderTopLeftRadius: getRpx(50),
    borderBottomLeftRadius: getRpx(12),
    marginBottom: getRpx(36),
  },
  goodsListScroll: {
    flexDirection: 'column',
    alignItems: 'center',
    width: getRpx(538),
    height: getRpx(420),
    paddingTop: getRpx(24),
  },
  btn: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    width: getRpx(290),
    height: getRpx(62),
    borderRadius: getRpx(35),
  },
  btnDisable: {
    backgroundColor: '#cccccc',
  },
  btnText: {
    color: '#ffffff',
    fontSize: getRpx(24),
  },
  goodsItem: {
    flexDirection: 'row',
    alignItems: 'center',
    height: getRpx(100),
  },
  mb36: {
    marginBottom: getRpx(36),
  },
  radio: {
    marginRight: getRpx(8),
  },
  goodsFace: {
    width: getRpx(100),
    height: getRpx(100),
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: getRpx(8),
    backgroundColor: '#fff',
  },
  SoldOutImage: {
    width: getRpx(110),
    height: getRpx(110),
  },
  goodsFaceImage: {
    width: getRpx(94),
    height: getRpx(94),
  },
  goodsInfoCur: {
    flexDirection: 'column',
    width: getRpx(386),
    marginLeft: getRpx(12),
  },
  goodsInfo: {
    flexDirection: 'column',
    width: getRpx(338),
    marginLeft: getRpx(12),
  },
  goodsName: {
    fontSize: getRpx(24),
    lineHeight: getRpx(32),
    marginBottom: getRpx(10),
  },
  goodsNameColor: {
    color: '#262626',
  },
  soldOutMask: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: getRpx(10),
    left: getRpx(10),
    zIndex: 1,
    width: getRpx(140),
    height: getRpx(140),
    backgroundColor: 'rgba(255,255,255,0.6)',
  },
  soldOutColor: {
    color: '#BFBFBF',
  },
  goodsPrice: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  goodsPriceType: {
    fontSize: getRpx(20),
    height: getRpx(24),
    alignItems: 'flex-end',
  },
  goodsPriceNum: {
    fontSize: getRpx(32),
    alignItems: 'flex-end',
    height: getRpx(36),
  },
  goodsPriceColor: {
    color: '#F2270C',
    alignItems: 'flex-end',
  },
  currentViewTag: {
    justifyContent: 'center',
    alignItems: 'center',
    height: getRpx(32),
    paddingLeft: getRpx(14),
    paddingRight: getRpx(14),
    borderTopLeftRadius: getRpx(20),
    borderTopRightRadius: getRpx(12),
    borderBottomLeftRadius: getRpx(20),
    overflow: 'hidden',
  },
  tagText: {
    fontSize: getRpx(20),
    color: '#ffffff',
  },
  currentViewIcon: {
    width: getRpx(12),
    height: getRpx(6),
    resizeMode: 'contain',
  },
  currentView: {
    position: 'absolute',
    top: -getRpx(16),
    right: 0,
    flexDirection: 'column',
    alignItems: 'flex-end',
  },

  vsIcon: {
    position: 'absolute',
    top: -getRpx(562),
    left: '50%',
    width: getRpx(86),
    height: getRpx(71),
    marginLeft: -getRpx(43),
  },
  dialogCloseClick: {
    position: 'absolute',
    right: getRpx(20),
    top: getRpx(20),
    zIndex: 10001,
    elevation: 5,
  },
  dialogClose: {
    width: getRpx(40),
    height: getRpx(40),
  },
});
interface IStoreProps {
  store: {
    entrySku: string;
    popup: boolean;
    skuBaseInfos: goodsItem[];
    selectList: goodsItem[];
    handleSelectList: goodsItem[];
    handleSelectGoods: (item: goodsItem, index: number) => void;
    addGoods: <T>() => Promise<T>;
    handleCloseSelect: () => void;
  };
}
interface IProps extends IStoreProps {}
class SelectContrastGoodsPage extends React.PureComponent<IProps, {}> {
  static contextTypes = {
    router: (PropTypes as any).object,
  };
  constructor(props: IProps) {
    super(props);
  }
  componentDidMount() {
    const {
      store: { entrySku },
    } = this.props;
    logClick({
      event_id: ContrastPopExpo,
      event_param: '',
      page_param: entrySku,
    });
  }
  handleCheck = (item: any, index: number) => {
    if (item.disabled) return;
    const { store } = this.props;
    store.handleSelectGoods(item, index);
  };
  handleAddGoods = () => {
    this.props.store.addGoods().then(() => {
      this.jumpTo();
    });
  };
  handleDisableAdd = () => {
    const {
      store: { handleSelectList },
    } = this.props;
    if (handleSelectList.length === 3) {
      JDNativeToast.show('请至少选择1个商品哦～', JDNativeToast.SHORT, JDNativeToast.FAIL);
    }
    if (handleSelectList.length === 0) {
      JDNativeToast.show('最多选择2个商品哦～', JDNativeToast.SHORT, JDNativeToast.FAIL);
    }
  };
  jumpTo = () => {
    logClick({
      event_id: ContrastPop,
      event_param: '',
      page_param: this.props.store.entrySku,
    }).then(
      (r: any) => {
        this.context.router.toGoodsContrast({ refresh: true });
      },
      (e: any) => {
        this.context.router.toGoodsContrast({ refresh: true });
      }
    );
  };
  handleClose = () => {
    this.props.store.handleCloseSelect();
    this.context.router.toGoodsContrast({ refresh: true });
  };
  render() {
    const skuBaseInfos = this.props.store.skuBaseInfos;
    const handleSelectList = this.props.store.handleSelectList;
    // const selectList = popup.skuBaseInfos;
    const currentView = skuBaseInfos.slice(0, 1)[0];
    const selectList = skuBaseInfos.slice(1);
    return (
      <>
        <View style={styles.container}>
          {Platform.OS !== 'web' ? (
            <>
              <TopNavigationBar isNormal={true} disableShare={true} title="选择商品" />
              <TopNavigationBarPlaceholder />
            </>
          ) : null}
          <View style={styles.mask}>
            <View style={styles.selectDialog}>
              <View style={styles.title}>
                <JDText style={styles.titleText}>请选择和它对比的商品</JDText>
              </View>
              <JDTouchable onPress={this.handleClose} style={styles.dialogCloseClick}>
                <JDImage source={Images.contrast.dialogClose} style={styles.dialogClose}></JDImage>
              </JDTouchable>
              {currentView ? (
                <View style={styles.current}>
                  <View style={styles.goodsItem}>
                    <View style={styles.goodsFace}>
                      <JDImage
                        source={{
                          uri: `https://m.360buyimg.com/n1/${currentView.skuIcon}`,
                        }}
                        style={styles.goodsFaceImage}
                      ></JDImage>
                    </View>
                    <View style={styles.goodsInfoCur}>
                      <JDText style={styles.goodsName} numberOfLines={2}>
                        {currentView.skuName}
                      </JDText>
                      <View style={styles.goodsPrice}>
                        {currentView.skuPrice && currentView.skuPrice.indexOf('.') != -1 ? (
                          <>
                            <JDText style={[styles.goodsPriceType, styles.goodsPriceColor]}>¥</JDText>
                            <JDText style={[styles.goodsPriceNum, styles.goodsPriceColor]}>
                              {currentView.skuPrice ? currentView.skuPrice.split('.')[0] : '-'}
                            </JDText>
                            <JDText style={[styles.goodsPriceType, styles.goodsPriceColor]}>.00</JDText>
                          </>
                        ) : (
                          <JDText>{currentView.skuPrice}</JDText>
                        )}
                      </View>
                    </View>
                  </View>
                  <View style={styles.currentView}>
                    <LinearGradient
                      colors={['rgba(255,202,110,1)', 'rgba(255,165,10,1)']}
                      start={{ x: 0, y: 0 }}
                      end={{ x: 1, y: 0 }}
                      style={styles.currentViewTag}
                    >
                      <JDText style={styles.tagText}>当前浏览</JDText>
                    </LinearGradient>
                    <JDImage
                      source={Images.selectContrastGoods.currentViewIcon}
                      style={styles.currentViewIcon}
                    ></JDImage>
                  </View>
                </View>
              ) : null}
              <View
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: 1000,
                  elevation: 4,
                  flexDirection: 'row',
                  justifyContent: 'center',
                  width: getRpx(582),
                  paddingTop: getRpx(236),
                }}
              >
                <JDImage
                  source={Images.contrast.vsIcon}
                  style={{
                    width: getRpx(86),
                    height: getRpx(71),
                  }}
                ></JDImage>
              </View>
              <View style={styles.goodsList}>
                {/* <JDScrollView style={styles.goodsListScroll}> */}
                <View style={styles.goodsListScroll}>
                  {selectList.map((item, index) => {
                    return (
                      <JDTouchable onPress={this.handleCheck.bind(this, item, index)}>
                        <View style={[styles.goodsItem, styles.mb36]}>
                          <View style={styles.radio}>
                            <Radio checked={!!item.checked} disabled={!!item.disabled} size={'small'}></Radio>
                          </View>
                          <View style={styles.goodsFace}>
                            <JDImage
                              source={{
                                uri: `https://m.360buyimg.com/n1/${item.skuIcon}`,
                              }}
                              style={styles.goodsFaceImage}
                            ></JDImage>
                          </View>
                          <View style={styles.goodsInfo}>
                            <JDText style={styles.goodsName} numberOfLines={2}>
                              {item.skuName}
                            </JDText>
                            <View style={styles.goodsPrice}>
                              {item.skuPrice && item.skuPrice.indexOf('.') != -1 ? (
                                <>
                                  <JDText style={[styles.goodsPriceType, styles.goodsPriceColor]}>¥</JDText>
                                  <JDText style={[styles.goodsPriceNum, styles.goodsPriceColor]}>
                                    {item.skuPrice ? item.skuPrice.split('.')[0] : '-'}
                                  </JDText>
                                  <JDText style={[styles.goodsPriceType, styles.goodsPriceColor]}>.00</JDText>
                                </>
                              ) : (
                                <JDText>{item.skuPrice}</JDText>
                              )}
                            </View>
                          </View>
                        </View>
                      </JDTouchable>
                    );
                  })}
                  {/* </JDScrollView> */}
                </View>
              </View>

              {handleSelectList && handleSelectList.length != 0 && handleSelectList.length <= 2 ? (
                <JDTouchable onPress={this.handleAddGoods}>
                  <LinearGradient
                    colors={['rgba(242,20,12,1)', 'rgba(242,39,12,1)', 'rgba(242,77,12,1)']}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 0 }}
                    style={styles.btn}
                  >
                    <JDText style={styles.btnText}>开始对比</JDText>
                  </LinearGradient>
                </JDTouchable>
              ) : (
                <JDTouchable onPress={this.handleDisableAdd}>
                  <LinearGradient
                    colors={['rgba(204,204,204,1)', 'rgba(204,204,204,1)', 'rgba(204,204,204,1)']}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 0 }}
                    style={styles.btn}
                  >
                    <JDText style={styles.btnText}>开始对比</JDText>
                  </LinearGradient>
                </JDTouchable>
              )}
              {/* <JDImage
                source={Images.contrast.vsIcon}
                style={{
                  position: 'absolute',
                  top: -getRpx(562),
                  left: '50%',
                  width: getRpx(86),
                  height: getRpx(71),
                  marginLeft: -getRpx(43),
                }}
              ></JDImage> */}
            </View>
          </View>
        </View>
      </>
    );
  }
}

const SelectContrastGoodsPageOberver = observer(SelectContrastGoodsPage);
const SelectContrastGoodsPageOberverWapper = (props: IProps) => (
  <SelectContrastGoodsPageOberver {...props} store={store} />
);
export default SelectContrastGoodsPageOberverWapper;
